import { BugOutlined } from "@ant-design/icons"

import { QuickWinBolt } from "./QuickWinBolt"

import styles from "./QuickWinIllustration.module.scss"

import type { CSSProperties } from "react"

interface QuickWinIllustrationProps {
  className?: string
  style?: CSSProperties
}

export const QuickWinIllustration = ({
  className,
  style
}: QuickWinIllustrationProps) => (
  <div
    className={`${styles.container}${className ? ` ${className}` : ""}`}
    style={style}
    aria-hidden="true"
  >
    <div className={`${styles.bugCard} ${styles.backLeft}`}>
      <BugOutlined className={styles.bugIcon} />
    </div>
    <div className={`${styles.bugCard} ${styles.backRight}`}>
      <BugOutlined className={styles.bugIcon} />
    </div>
    <div className={`${styles.bugCard} ${styles.front}`}>
      <BugOutlined className={styles.bugIcon} />
    </div>
    <div className={styles.thunderboltBadge}>
      <QuickWinBolt
        className={styles.thunderboltIcon}
        fillClassName={styles.thunderboltFill}
        fill="white"
      />
    </div>
  </div>
)
